var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Map, NavigationControl } from "mapbox-gl";
import MapLocation from "./base/MapLocation";
import BaseMap from "./base/BaseMap";
import { createUserMarker } from "./mapbox/Util";
import MapboxMarker from "./mapbox/MapboxMarker";
import { None } from "./MapMarkerIcons";
import MapboxLocation from "./mapbox/MapboxLocation";
var MapboxMap = /** @class */ (function (_super) {
    __extends(MapboxMap, _super);
    function MapboxMap() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MapboxMap.prototype.initializeMap = function (userLocation) {
        this.map = new Map({
            accessToken: atob('cGsuZXlKMUlqb2lZV2RwYkdsemNtVm5aVzV6WW5WeVp5SXNJbUVpT2lKamJHd3lNM293ZGpFd2VUUTVNMlJ4Y21SaGRIRnNiSEkwSW4wLmJ5V1k1QTM4d2pjNEpRa1BRNlBVQkE='),
            container: this.container,
            style: 'mapbox://styles/agilisregensburg/cllf2tf6c013101p849cnblmo',
            center: new MapboxLocation(userLocation).toMapboxLngLat(),
            zoom: 8
        });
        this.map.addControl(new NavigationControl());
        this.map.scrollZoom.disable();
        return this.map;
    };
    MapboxMap.prototype.createUserMarker = function (userLocation) {
        createUserMarker(this.map, new MapboxLocation(userLocation).toMapboxLngLat());
        var markerLocation = new MapLocation(-1, userLocation.lat, userLocation.lng, 'Agilis', []);
        markerLocation.teaser = 'Hier befindet sich unsere Verwaltung. Hier wird gedacht, geplant und auch gelacht.';
        this.createMarker(markerLocation, None, false);
    };
    MapboxMap.prototype.createPolyline = function (id, color, locations) {
        var _this = this;
        this.map.on('load', function () {
            _this.map.addSource(id, {
                type: 'geojson',
                data: {
                    type: 'Feature',
                    properties: {},
                    geometry: {
                        type: 'LineString',
                        coordinates: locations.map(function (it) { return it.toLngLat(); })
                    }
                }
            });
            _this.map.addLayer({
                id: id,
                type: 'line',
                source: id,
                layout: {
                    "line-join": 'round',
                    "line-cap": 'round'
                },
                paint: {
                    "line-color": color.length == 0 ? '#ccdd00' : color,
                    "line-width": 4
                }
            });
            //console.debug("Added Map Layer %o (%o) >> %o", id, color, locations.map(it => [it.lng, it.lat]))
        });
        /*if (!this.map.loaded) {
            this.map.on('load', () => this.createPolylineInternal(id, color, locations));
        } else {
            this.createPolylineInternal(id, color, locations);
        }*/
    };
    MapboxMap.prototype.setCenter = function (location) {
        //this.map.setCenter(new MapboxLocation(location).toMapboxLngLat());
        this.map.flyTo({
            center: new MapboxLocation(location).toMapboxLngLat(),
            zoom: 14,
            duration: 2000
        });
    };
    MapboxMap.prototype.createMarkerInternal = function (location, icon) {
        return new MapboxMarker(location.getPrimaryCategorySlug(), icon, location).addTo(this);
    };
    return MapboxMap;
}(BaseMap));
export default MapboxMap;
